import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneFormat',
  standalone: true,
})

export class PhoneFormatPipe implements PipeTransform {

  transform(
    value: string | null | undefined,
    dialCode?: string,
    mask?: string
  ): string {

    if (!value) {
      return '';
    }

    const raw = String(value).trim();
    const digits = raw.replace(/\D/g, '');

    // US / Canada: 11 digits starting with 1  ->  +1 (555) 123-4567
    if (digits.length === 11 && digits.startsWith('1')) {
      return `+1 (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
    }

    // Plain 10-digit number (no country code)  ->  (555) 123-4567
    if (digits.length === 10) {
      return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
    }

    // Already an international number (e.g. "+919881466649"): it carries its own country
    // code, so do NOT prepend the dial code again — that produced "+91 +919881466649".
    if (raw.startsWith('+')) {
      return raw;
    }

    return dialCode ? `${dialCode} ${raw}` : raw;
  }
}